import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {Region} from './region.model';

export const RegionActions = createActionGroup({
  source: 'Region/API',
  events: {
    'Load Regions': props<{ regions: Region[] }>(),
    'Add Region': props<{ region: Region }>(),
    'Upsert Region': props<{ region: Region }>(),
    'Add Regions': props<{ regions: Region[] }>(),
    'Upsert Regions': props<{ regions: Region[] }>(),
    'Update Region': props<{ region: Update<Region> }>(),
    'Update Regions': props<{ regions: Update<Region>[] }>(),
    'Delete Region': props<{ id: string }>(),
    'Delete Regions': props<{ ids: string[] }>(),
    'Clear Regions': emptyProps(),

    // Effect actions
    'Get All Regions': emptyProps(),
    'Regions Loading State': props<{ loading: boolean }>(),
  }
});
